<div *ngIf="activeFileRecord">
    <tbody class="submInfo-container" >
        <tr>
            <td class="category">HML ID</td>
            <td class="val"><em class="material-icons dash-link-icon">link</em><span class="click-me" matTooltip={{activeFileRecord.hmlId}} (click)="displaySourceDialog(activeFileRecord.uuid, activeFileRecord.hmlId, activeFileRecord.uploaderFileName, activeFileRecord.status, activeFileRecord.testType)">{{activeFileRecord.hmlId}}</span></td>
        </tr>
        <tr>
            <td class="category">Reporting Center </td>
            <td class="val">{{activeFileRecord.reportingCenter}}</td>
        </tr>
        <tr>
            <td class="category">Received (CST) </td>
            <td class="val">{{activeFileRecord.receivedDate}}</td>
        </tr>
        <tr>
            <td class="category">Status </td>
            <td class="val">{{activeFileRecord.status}}</td>
        </tr>
        <tr>
            <td class="category">Step code </td>
            <td class="val">{{activeFileRecord.stepCode}}</td>
        </tr>
        <tr>
            <td class="category">Description </td>
            <td class="val">{{activeFileRecord.processDesc}}</td>
        </tr>
        <tr>
            <td class="category">Application </td>
            <td class="val">{{activeFileRecord.applicationName}}</td>
        </tr>
    </tbody>
    <mat-icon matTooltip="Copy UUID" class="icon copy rotate" (click)="copyMessage($event, activeFileRecord.uuid)">content_copy</mat-icon>
    <div class="submission-info-notes"><h2>Notes</h2></div>
    <div this.notesComponent2><notes-component #notesComponentSubmissionInfo></notes-component></div>
</div>
